import React, { useState } from 'react';

// Открывается вместо голого window.confirm при клике «Отменить подписку» —
// стандартный SaaS-приём: предложить альтернативу перед финальной отменой,
// ловит часть уходящих, которым просто «дорого сейчас», а не принципиально не нужно.
const CancelRetentionModal = ({ discountPercent, onStay, onDowngrade, onCancel, onClose }) => {
  const [busy, setBusy] = useState(false);

  const run = async (action) => {
    setBusy(true);
    try {
      await action();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="ui-modal" onClick={onClose} role="presentation">
      <div className="ui-modal-box" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="ui-modal-head">
          <h2>Прежде чем отменить</h2>
          <button className="ui-icon-btn" type="button" onClick={onClose} aria-label="Закрыть">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
              <path d="M19.0068 5L5.00684 19" /><path d="M19 19L5 5" />
            </svg>
          </button>
        </div>

        <p className="ui-dim">Может, дело не в продукте, а в цене прямо сейчас — есть варианты помягче полной отмены.</p>

        <div className="ui-form-actions cancel-retention-actions">
          <button type="button" className="ui-btn-primary" disabled={busy} onClick={() => run(onStay)}>
            Остаться со скидкой {discountPercent}% на следующее списание
          </button>
          <button type="button" className="ui-btn-ghost" disabled={busy} onClick={() => run(onDowngrade)}>
            Перейти на тариф дешевле
          </button>
          <button type="button" className="ui-btn-danger" disabled={busy} onClick={() => run(onCancel)}>
            Всё равно отменить
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelRetentionModal;
